import React, { useCallback, useEffect } from "react";
import { Modal } from "antd";
import styled from "styled-components";

export const SubmitModal = ({ isVisible, title, onOk, onCancel, message }) => {
  //Trigger search when press enter on the keyboard
  const handleKeyDown = useCallback(
    (e) => {
      if (e.key === "Enter") {
        onOk();
      }
    },
    [onOk]
  );

  // Add event listener when the modal display
  useEffect(() => {
    if (isVisible) {
      window.addEventListener("keydown", handleKeyDown);
    }

    return () => {
      window.removeEventListener("keydown", handleKeyDown);
    };
  }, [isVisible, handleKeyDown]);

  const handleOk = () => {
    onOk();
  };

  return (
    <StyledModal
      title={title}
      open={isVisible}
      onOk={handleOk}
      footer={[
        <button className="custom-modal-button" key="submit" onClick={handleOk}>
          OK
        </button>,
      ]}
      centered
    >
      <p>{message}</p>
    </StyledModal>
  );
};

const StyledModal = styled(Modal)`
  .ant-modal-title {
    font-size: var(--h5-font-size);
  }
`;
